import { ConditionMatcherFactory } from "./ConditionMatcher"
import { Target, TargetCondition } from "../../model/model"
import EvaluateRequest from "../EvaluateRequest"
import { EvaluatorContext } from "../evaluator/Evaluator"

export default class TargetMatcher {
  private conditionMatcherFactory: ConditionMatcherFactory

  constructor(conditionMatcherFactory: ConditionMatcherFactory) {
    this.conditionMatcherFactory = conditionMatcherFactory
  }

  matches(request: EvaluateRequest, context: EvaluatorContext, target: Target): boolean {
    return target.conditions.every((it) => this._matches(request, context, it))
  }

  anyMatches(request: EvaluateRequest, context: EvaluatorContext, targets: Target[]): boolean {
    if (!targets.length) return true
    return targets.some((target) => this.matches(request, context, target))
  }

  private _matches(request: EvaluateRequest, context: EvaluatorContext, condition: TargetCondition): boolean {
    const conditionMatcher = this.conditionMatcherFactory.getMatcher(condition.key.type)
    return conditionMatcher.matches(request, context, condition)
  }
}
